import styled from "@emotion/styled";
import { fontBarlowSemiCondensed } from "@product/scmp-sdk";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ContentContainer = styled.div`
  inline-size: max-content;
`;

export const Headline = styled.div`
  color: #222222;
  font-weight: 700;
  font-size: 20px;
  font-family: ${fontBarlowSemiCondensed};
  line-height: 28px;

  ${props => props.theme.breakpoints.up("desktop")} {
    font-size: 24px;
    line-height: 28px;
  }
`;

export const Text = styled.div`
  color: #222222;
  font-size: 18px;
  font-family: ${fontBarlowSemiCondensed};
  line-height: 22px;

  ${props => props.theme.breakpoints.up("desktop")} {
    font-size: 22px;
    line-height: 26px;
  }
`;

export const ExploreNow = styled.div`
  display: flex;
  align-items: flex-start;

  inline-size: max-content;
  padding-block: 8px;
  padding-inline: 12px;

  color: #222222;
  font-size: 14px;
  font-family: ${fontBarlowSemiCondensed};
  letter-spacing: 0.7px;

  border: 1px solid #222222;
  border-radius: 4px;
`;
